import { Text } from '@components/ui';
import Grid from '@mui/material/Grid';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { TextValidator } from 'react-material-ui-form-validator';

import type { ScrappedItemDetails } from './updateHireJobFieldsTypes';

interface UpdateHireJobFieldsProps {
  itemIdDataObject: ScrappedItemDetails | undefined;
  handleItemDataChangeObject: (event: ChangeEvent<HTMLInputElement>) => void;
  description: string | undefined;
  handleChangeObject: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function UpdateHireJobFields({
  itemIdDataObject,
  handleItemDataChangeObject,
  description,
  handleChangeObject,
}: UpdateHireJobFieldsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Text
        variant="label"
        sx={{
          mt: 1.25,
          mb: 1.25,
          display: 'block',
          textTransform: 'uppercase',
          fontWeight: 700,
        }}
      >
        {t('hire.jobDetails')}
      </Text>
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        spacing={2}
        style={{ display: 'flex' }}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.vinSerial')}
            onChange={handleItemDataChangeObject}
            type="text"
            name="vIN"
            value={itemIdDataObject?.vIN ? itemIdDataObject?.vIN : ''}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.year')}
            onChange={handleItemDataChangeObject}
            type="number"
            name="year"
            value={itemIdDataObject?.year ? String(itemIdDataObject.year) : ''}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.make')}
            onChange={handleItemDataChangeObject}
            type="text"
            name="make"
            value={itemIdDataObject?.make ? itemIdDataObject?.make : ''}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.model')}
            onChange={handleItemDataChangeObject}
            type="text"
            name="model"
            value={itemIdDataObject?.model ? itemIdDataObject?.model : ''}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.description')}
            onChange={(event) => handleChangeObject(event)}
            type="text"
            name="description"
            value={description}
          />
        </Grid>
      </Grid>
    </>
  );
}
